import {Pipe, PipeTransform} from '@angular/core';
import dayjs from "dayjs";

@Pipe({name: 'timeAgoAt', standalone: true, pure: true})
export class TimeAgoAtPipe implements PipeTransform {
    transform(value: string | number | Date, now: number | null | undefined, numeric = false): string | number {
        const base = dayjs(now ?? Date.now()).startOf('day');
        let d: dayjs.Dayjs;
        if (typeof value === 'string') {
            const s = value.trim();
            d = dayjs(s.slice(0, 10), 'DD/MM/YYYY', true);
            if (!d.isValid()) d = dayjs(s, ['DD/MM/YYYY HH:mm:ss', 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD[T]HH:mm:ss[Z]'], true);
        } else {
            d = dayjs(value);
        }
        if (!d.isValid()) return numeric ? NaN : '—';
        d = d.startOf('day');
        const diff = base.diff(d, 'day');
        if (numeric) return diff;
        if (diff === 0) return 'hoy';
        return diff > 0 ? `hace ${diff} día${diff === 1 ? '' : 's'}` : `en ${-diff} día${diff === -1 ? '' : 's'}`;
    }
}
